module.exports = __webpack_public_path__ + "static/media/video_4.9eb4044f.mp4";